'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '@mui/material/Button';
import { RESUME_EVALUATION_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import ResumeEvaluationImage from '@/assets/marketing/resume-evaluation.png';
import TopBannerBgImage from '@/assets/marketing/resume-evaluation-bg.png';

const NewTopBanner = (props: { isTopBanner?: boolean }) => {
  const { isTopBanner = true } = props;

  return (
    <div
      data-observer-id="marketing_banner_evaluation"
      data-ele-group="marketing_banner_evaluation"
      data-ele-id="banner_AI智能简历诊断！"
      className={`rounded-lg px-4 overflow-hidden flex flex-col items-center justify-between relative bg-no-repeat bg-top bg-cover ${isTopBanner ? 'mb-10' : 'mb-6'} tablet:flex-row tablet:px-10`}
      style={{ backgroundImage: `url(${TopBannerBgImage.src})` }}
    >
      <div className="flex flex-col py-4 items-center tablet:py-7 tablet:mr-5 tablet:flex-row">
        <div className="text-sm text-amber-900">
          <p className="text-1.5xl font-semibold text-amber-700">
            AI智能简历诊断！
          </p>
          <p className={`${isTopBanner ? 'mt-1.5' : 'mt-3 text-base'}`}>
            想知道你的简历存在什么问题吗？
          </p>
          <p
            className={`${isTopBanner ? 'w-full mt-1.5' : 'mt-3 tablet:max-w-[472px]'}`}
          >
            从简历规范度、职业形象塑造、职场经历、核心能力、职场竞争力五个维度综合评估，为你的求职保驾护航！
          </p>
          {!isTopBanner && (
            <Button
              className="w-full mt-10 h-[45px] !font-semibold !rounded-full !tracking-[1px] tablet:w-[210px]"
              variant="contained"
              LinkComponent={Link}
              href={RESUME_EVALUATION_ROUTER_PATH}
              onClick={(e) => {
                trackClickEvent(e);
              }}
            >
              立即诊断
            </Button>
          )}
        </div>
        {isTopBanner && (
          <Button
            className="w-full h-[45px] !font-semibold !rounded-full !tracking-[1px] tablet:w-[150px]"
            variant="contained"
            LinkComponent={Link}
            href={RESUME_EVALUATION_ROUTER_PATH}
            onClick={trackClickEvent}
          >
            立即诊断
          </Button>
        )}
      </div>
      <div
        className={`hidden my-2.5 relative tablet:block ${isTopBanner ? 'tablet:w-[150px] tablet:h-[130px]' : 'tablet:w-[300px] tablet:h-[260px]'}`}
      >
        <Image alt="" src={ResumeEvaluationImage} />
      </div>
    </div>
  );
};

export default NewTopBanner;
